export default __webpack_public_path__ + "2eeadf12e62c693c7b018a4999eb5d5c.svg";